import React, { useEffect, useState } from "react";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { constant } from "constants/constant";
import "./editAccounting.css";
import { errorSchema, utils } from "helper";
import toast from "react-hot-toast";
import { StorageServices } from "utils";
import { updateBankAccountApi, updateCashAccountApi, updateOtherAccountApi } from "_services";
import StorageService from "utils/StorageServices";
import { getUserFirm } from "_services/accountsServices/firmServices";

const EditAccountingModal = (props) => {
    const { accountDetails, callBack } = props;

    // 🔥 Local Form State (Dynamic)
    const [form, setForm] = useState({

        company_id: StorageServices?.getCompanyId(),
        account_id: accountDetails?._id,

        cash_name: accountDetails?.name || "",
        cash_opting_bal: accountDetails?.opening_balance || "",
        cash_credit_or_debit: accountDetails?.credit_or_debit || 1,
        show_cash_prefix: accountDetails?.prefix ? true : false,
        cash_prefix: accountDetails?.prefix,
        firm_id: accountDetails?.firm_list[0] ? { label: accountDetails?.firm_list[0]?.firm_name, value: accountDetails?.firm_list[0]?.firm_id } : {},


        holder_name: accountDetails?.name || "",
        number: accountDetails?.number || "",
        ifsc: accountDetails?.ifsc || "",
        bank: accountDetails?.bank || "",
        bank_opening_balance: accountDetails?.opening_balance || "",
        bank_credit_or_debit: accountDetails?.credit_or_debit || 1,
        bank_prefix: accountDetails?.prefix,
        show_bank_prefix: accountDetails?.prefix ? true : false,
        vendor_account: accountDetails?.vendor_account,

        other_name: accountDetails?.name || "",
        other_opening_balance: accountDetails?.opening_balance || "",
        other_credit_or_debit: accountDetails?.credit_or_debit || 1,
        other_prefix: accountDetails?.prefix,
        show_other_prefix: accountDetails?.prefix ? true : false,

    });

    console.log(form)

    const [formError, setFormError] = useState("");
    const [loading, setLoading] = useState(false);
    const [firmDataList, setFirmDataList] = useState([]);


    const getDataFirmList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
            }
            const res = await getUserFirm(object);
            if (res?.responseCode == 200) {
                let apiData = res?.data?.firm_list?.map((el) => {
                    return {
                        label: el?.firm_id?.firm,
                        value: el?.firm_id?._id,
                    }
                })
                setFirmDataList(apiData);
                // if (!isOpen?._id) {
                // if (apiData?.length === 1) {
                //     setForm((s) => ({
                //         ...s,
                //         firm_id: apiData[0]
                //     }))
                // } else {
                //     setForm((s) => ({
                //         ...s,
                //         firm_id: {}
                //     }))
                // }
                // }
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        getDataFirmList();
    }, [])


    const handleSearch = async (ifscCode) => {
        // Fetch bank details from Razorpay IFSC API

        const validateIFSC = (code) => {
            const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
            return ifscRegex.test(code.toUpperCase());
        };
        const valid = validateIFSC(ifscCode);


        if (valid) {
            console.log("Valid IFSC code. Proceeding to fetch details...");
            try {
                const res = await fetch(`https://ifsc.razorpay.com/${ifscCode}`);
                if (!res.ok) {
                    return res
                }
                const data = await res.json();
                return data
            } catch (err) {
                toast.error(err.message);
            }
        }
    }

    // 🔥 Generic Input Handler
    const handleChange = async (field, value) => {
        const stateObj = { ...form, [field]: value };

        if (field === "ifsc" && value.length === 11) {
            console.log("IFSC code entered, fetching bank details...");
            try {
                const bankDetails = await handleSearch(value);

                if (bankDetails && bankDetails.BRANCH) {
                    stateObj.branch_name = bankDetails.BRANCH;
                    stateObj.branch_code = bankDetails.BANKCODE;
                    stateObj.city_name = bankDetails.CITY;
                    stateObj.state_name = bankDetails.STATE;
                    stateObj.bank = bankDetails.BANK

                } else {

                    stateObj.branch_name = "";
                    stateObj.bank = ""
                    setFormError(prev => ({
                        ...prev,
                        ifsc: "invalid IFSC code",
                    }));
                }
            } catch (error) {
                console.error("Error fetching bank details:", error);
                stateObj.branch_name = "";
                stateObj.bank = ""
            }
        }

        setForm(stateObj);

        if (!!formError) {
            const validationSchemas = {
                3: errorSchema.cashSchema,
                2: errorSchema.bankSchema,
                14: errorSchema.otherSchema,

            };
            const validationResult = await utils.checkFormError(
                stateObj,
                validationSchemas[accountDetails?.parent_account_id]
            );

            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };



    const handleOnSubmit = async () => {
        const validationSchemas = {
            3: errorSchema.cashSchema,
            2: errorSchema.bankSchema,
            14: errorSchema.otherSchema,
        };

        const validationResult = await utils.checkFormError(
            { ...form },
            validationSchemas[accountDetails?.parent_account_id]
        );

        const payloads = {
            3: {
                company_id: form?.company_id,
                account_id: form?.account_id,
                name: form?.cash_name,
                opening_balance: form?.cash_opting_bal,
                credit_or_debit: form?.cash_credit_or_debit,
                prefix: form?.cash_prefix,
                firm_id: form?.firm_id?.value,
                firm_name: form?.firm_id?.label
            },
            2: {
                company_id: form?.company_id,
                account_id: form?.account_id,
                name: form?.holder_name,
                number: form?.number,
                ifsc: form?.ifsc,
                bank: form?.bank,
                opening_balance: form?.bank_opening_balance,
                credit_or_debit: form?.bank_credit_or_debit,
                prefix: form?.bank_prefix,
                vendor_account: form?.vendor_account,
                firm_id: form?.firm_id?.value,
                firm_name: form?.firm_id?.label
            },

            14: {
                company_id: form?.company_id,
                account_id: form?.account_id,
                name: form?.other_name,
                opening_balance: form?.other_opening_balance,
                credit_or_debit: form?.other_credit_or_debit,
                prefix: form?.other_prefix,
                firm_id: form?.firm_id?.value,
                firm_name: form?.firm_id?.label
            }
        };

        const apiCalls = {
            3: updateCashAccountApi,
            2: updateBankAccountApi,
            14: updateOtherAccountApi,
        };

        if (validationResult == true) {
            setLoading(true);
            try {
                const payload = payloads[accountDetails?.parent_account_id];
                const apiCall = apiCalls[accountDetails?.parent_account_id];

                if (!payload || !apiCall) {
                    toast?.error("Invalid tab or missing payload");
                    return;
                }

                const res = await apiCall(payload);

                if (res?.responseCode == 200) {
                    setLoading(false);
                    callBack()
                }

            } catch (error) {
                setLoading(false);
                console.error("Error:", error);
            }
        } else {
            setLoading(false);
            setFormError(validationResult);
        }
    };

    const propsAdjustLedger = {
        onSubmit: handleOnSubmit,
        isLoadding: loading,
        firm: form?.firm_id,
        ...props
    };

    return (
        <CommonModal {...propsAdjustLedger}>
            <div className="__adjBal_mx">
                <div className="__adjmid_part" style={{ borderTop: "0px" }}>
                    {accountDetails?.parent_account_id == 3 &&

                        <div className="__adS_main_fx">
                            {firmDataList?.length > 1 && <div className='singleDiv'>
                                <CustomSelect
                                    options={firmDataList}
                                    label="Select Firm"
                                    placeholder="Select Firm"
                                    name="firm_id"
                                    value={form?.firm_id}
                                    error={formError["firm_id.label"]}
                                    onSelect={(data) => handleChange('firm_id', data)}
                                />
                            </div>}
                            {/* Cash Account Name */}
                            <div className="singleDiv">
                                <CommonInput
                                    type="text"
                                    placeholder="Cash Account Name"
                                    label="Cash Account Name"
                                    focus={!!formError?.cash_name}
                                    error={formError.cash_name}
                                    name="cash_name"
                                    value={form.cash_name}
                                    onChange={(e) => handleChange("cash_name", e.target.value)}
                                />
                            </div>

                            {/* Opening Balance */}
                            <div className="singleDiv">
                                <CommonInput
                                    type="text"
                                    placeholder="Opening Balance"
                                    label="Opening Balance"
                                    name="cash_opting_bal"
                                    focus={!!formError?.cash_opting_bal}
                                    error={formError.cash_opting_bal}
                                    value={form.cash_opting_bal}
                                    onChange={(e) =>
                                        handleChange("cash_opting_bal", e.target.value)
                                    }
                                />
                            </div>

                            {/* Credit / Debit Radio */}
                            <div className="checkBx_lv mt-0 p-0" style={{ width: "100%" }}>
                                {constant.BalancesRadio?.map((el, ind) => {
                                    return (
                                        <div className="_dualCheckr_bx" key={ind}>
                                            <input
                                                style={{ marginTop: "2px" }}
                                                className="form-check-input"
                                                id={`crdr-${ind}-${el.value}`}
                                                type="radio"
                                                name="cash_credit_or_debit"
                                                value={el.value}
                                                checked={form.cash_credit_or_debit === el.value}
                                                onChange={() =>
                                                    handleChange("cash_credit_or_debit", el.value)
                                                }
                                            />
                                            <label
                                                htmlFor={`crdr-${ind}-${el.value}`}
                                                className="form-check-label"
                                                style={{ fontSize: "14px" }}
                                            >
                                                {el.label}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Add More Details Button */}
                            <div className="singleDiv" style={{ textAlign: "right" }}>
                                <button className="anime-btn __apprBtn" onClick={() => handleChange("show_cash_prefix", true)}>Add More Detail</button>
                            </div>

                            {form?.show_cash_prefix && (
                                <div>
                                    <CommonInput
                                        type="text"
                                        placeholder="Prefix"
                                        label="Prefix"
                                        name="cash_prefix"
                                        focus={!!formError?.cash_prefix}
                                        error={formError.cash_prefix}
                                        onChange={({ target: { name, value } }) =>
                                            handleChange(name, value)
                                        }
                                        value={form?.cash_prefix}
                                    />
                                    <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                                </div>
                            )}
                        </div>

                    }

                    {accountDetails?.parent_account_id === 2 && (
                        <>
                            <div className="_allDflx mt-4">
                                {firmDataList?.length > 1 && <div className='singleDiv'>
                                    <CustomSelect
                                        options={firmDataList}
                                        label="Select Firm"
                                        placeholder="Select Firm"
                                        name="firm_id"
                                        value={form?.firm_id}
                                        error={formError["firm_id.label"]}
                                        onSelect={(data) => handleChange('firm_id', data)}
                                    />
                                </div>}
                                <div>
                                    <CommonInput
                                        type="text"
                                        placeholder="Bank Account Name"
                                        label="Bank Account Name"
                                        name="holder_name"
                                        focus={!!formError?.holder_name}
                                        error={formError.holder_name}
                                        onChange={({ target: { name, value } }) =>
                                            handleChange(name, value)
                                        }
                                        value={form?.holder_name}
                                        maxLength={30}
                                    />
                                </div>

                                <div>
                                    <CommonInput
                                        type="text"
                                        placeholder="Ex.123456789012345"
                                        label="Account Number"
                                        name="number"
                                        // focus={!!formError?.number}
                                        // error={formError.number}
                                        onChange={({ target: { name, value } }) => {
                                            if (/^\d*$/.test(value)) {
                                                handleChange(name, value);
                                            }
                                        }}
                                        maxLength={20}
                                        value={form?.number}
                                    />
                                </div>

                                <div>
                                    <CommonInput
                                        type="text"
                                        placeholder="Ex.SBIN0000000"
                                        label="IFSC Code"
                                        name="ifsc"
                                        focus={!!formError?.ifsc}
                                        error={formError.ifsc}
                                        // onChange={({ target: { name, value } }) =>
                                        //   handleChange(name, value)
                                        // }
                                        onChange={({ target: { name, value } }) => {

                                            const upperLatter = value.toUpperCase();

                                            handleChange(name, upperLatter)
                                        }

                                        }
                                        value={form?.ifsc}
                                        maxLength={11}
                                    />
                                </div>

                                {/* <div>
                              <CustomSelect
                                options={bankList}
                                label="Bank Name"
                                placeholder="Bank Name"
                                name="bank"
                                // focus={!!formError?.bank}
                                // error={formError.bank}
                                onSelect={(data) => handleChange("bank", data?.value)}
                                value={bankList?.find((i) => i?.value == form?.bank)}
                              />
                            </div> */}

                                <div>
                                    <CommonInput
                                        type="text"
                                        placeholder="Opening Balance "
                                        label="Opening Balance (₹)"
                                        name="bank_opening_balance"
                                        className="__rupeeSymbol"
                                        rupeeSymbol={true}
                                        focus={!!formError?.bank_opening_balance}
                                        error={formError.bank_opening_balance}
                                        onChange={({ target: { name, value } }) => {
                                            const validValue = value.replace(/[^0-9.]/g, "");
                                            const formattedValue = validValue.includes(".")
                                                ? validValue.split(".")[0] +
                                                "." +
                                                validValue.split(".")[1].slice(0, 2)
                                                : validValue;

                                            handleChange(name, formattedValue);
                                        }}
                                        value={form?.bank_opening_balance}
                                        maxLength={10}
                                    />
                                </div>

                                <div className="d-flex gap-4">
                                    {[
                                        { label: "(+) Balance", value: 1 },
                                        { label: "(-) Balance", value: 2 },
                                    ].map((i) => (
                                        <div className="_dualCheckr_bx" key={i?.value}>
                                            <input
                                                className="form-check-input"
                                                id={i?.label}
                                                type="radio"
                                                name="bank_credit_or_debit"
                                                checked={i.value == form.bank_credit_or_debit}
                                                value={i.value}
                                                onChange={({ target: { name, value } }) =>
                                                    handleChange(name, Number(value))
                                                }
                                            />
                                            <label htmlFor={i?.label} className="form-check-label">
                                                {i?.label}
                                            </label>
                                        </div>
                                    ))}
                                </div>

                                {!form?.show_bank_prefix && (
                                    <div className="d-flex justify-content-end">
                                        <button
                                            className="_addMo_deBtn"
                                            onClick={() => handleChange("show_bank_prefix", true)}
                                        >
                                            Add More Detail
                                        </button>
                                    </div>
                                )}
                                <div className="d-flex gap-4">
                                    Supplier / Vendor Account
                                </div>
                                <div className="d-flex gap-4">
                                    {[
                                        { label: "Required", value: true },
                                        { label: "Not Required", value: false },
                                    ].map((i) => (
                                        <div className="_dualCheckr_bx" key={i.label}>
                                            <input
                                                className="form-check-input"
                                                id={i.label}
                                                type="radio"
                                                name="vendor_account"
                                                checked={form.vendor_account === i.value}
                                                value={i.value}
                                                onChange={({ target }) =>
                                                    handleChange(target.name, target.value === "true")
                                                }
                                            />
                                            <label htmlFor={i.label} className="form-check-label">
                                                {i.label}
                                            </label>
                                        </div>
                                    ))}
                                </div>

                                {form?.show_bank_prefix && (
                                    <div>
                                        <CommonInput
                                            type="text"
                                            placeholder="Prefix"
                                            label="Prefix"
                                            name="bank_prefix"
                                            focus={!!formError?.bank_prefix}
                                            error={formError.bank_prefix}
                                            onChange={({ target: { name, value } }) =>
                                                handleChange(name, value)
                                            }
                                            value={form?.bank_prefix}
                                        />
                                        <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    {accountDetails?.parent_account_id === 14 && (
                        <>
                            <div className="_allDflx mt-4">
                                {firmDataList?.length > 1 && <div className='singleDiv'>
                                    <CustomSelect
                                        options={firmDataList}
                                        label="Select Firm"
                                        placeholder="Select Firm"
                                        name="firm_id"
                                        value={form?.firm_id}
                                        error={formError["firm_id.label"]}
                                        onSelect={(data) => handleChange('firm_id', data)}
                                    />
                                </div>}
                                <div>
                                    <CommonInput
                                        type="text"
                                        placeholder="Account Name"
                                        label="Account Name"
                                        name="other_name"
                                        focus={!!formError?.other_name}
                                        error={formError.other_name}
                                        onChange={({ target: { name, value } }) =>
                                            handleChange(name, value)
                                        }
                                        value={form?.other_name}
                                        maxLength={30}
                                    />
                                </div>

                                <div>
                                    <CommonInput
                                        type="text"
                                        placeholder="Opening Balance "
                                        label="Opening Balance (₹)"
                                        name="other_opening_balance"
                                        className="__rupeeSymbol"
                                        rupeeSymbol={true}
                                        focus={!!formError?.other_opening_balance}
                                        error={formError.other_opening_balance}
                                        onChange={({ target: { name, value } }) => {
                                            const validValue = value.replace(/[^0-9.]/g, "");
                                            const formattedValue = validValue.includes(".")
                                                ? validValue.split(".")[0] +
                                                "." +
                                                validValue.split(".")[1].slice(0, 2)
                                                : validValue;

                                            handleChange(name, formattedValue);
                                        }}
                                        value={form?.other_opening_balance}
                                        maxLength={10}
                                    />
                                </div>

                                <div className="d-flex gap-4">
                                    {[
                                        { label: "(+) Balance", value: 1 },
                                        { label: "(-) Balance", value: 2 },
                                    ].map((i) => (
                                        <div className="_dualCheckr_bx" key={i?.value}>
                                            <input
                                                className="form-check-input"
                                                id={i?.label}
                                                type="radio"
                                                name="other_credit_or_debit"
                                                checked={i.value == form.other_credit_or_debit}
                                                value={i.value}
                                                onChange={({ target: { name, value } }) =>
                                                    handleChange(name, Number(value))
                                                }
                                            />
                                            <label htmlFor={i?.label} className="form-check-label">
                                                {i?.label}
                                            </label>
                                        </div>
                                    ))}
                                </div>

                                {!form?.show_other_prefix && (
                                    <div className="d-flex justify-content-end">
                                        <button
                                            className="_addMo_deBtn"
                                            onClick={() => handleChange("show_other_prefix", true)}
                                        >
                                            Add More Detail
                                        </button>
                                    </div>
                                )}

                                {form?.show_other_prefix && (
                                    <div>
                                        <CommonInput
                                            type="text"
                                            placeholder="Prefix"
                                            label="Prefix"
                                            name="other_prefix"
                                            focus={!!formError?.other_prefix}
                                            error={formError.other_prefix}
                                            onChange={({ target: { name, value } }) =>
                                                handleChange(name, value)
                                            }
                                            value={form?.other_prefix}
                                        />
                                        <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </CommonModal>
    );
};

export default EditAccountingModal;
